import { render, staticRenderFns } from "./taskTypeManagement.vue?vue&type=template&id=c21b3256&scoped=true"
import script from "./taskTypeManagement.vue?vue&type=script&lang=js"
export * from "./taskTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./taskTypeManagement.vue?vue&type=style&index=0&id=c21b3256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21b3256",
  null
  
)

export default component.exports